import { Log } from "@src/utils";
import { create } from "zustand";
import type { Merit } from "@src/api/issuance";
import type { NotificationResponse } from "expo-notifications";

// TODO: use backend generated types
export enum NotificationType {
  MERIT_UPDATED = "MeritUpdated",
  MERIT_RECEIVED = "MeritReceived",
}

type MeritReceivedPayload = {
  readonly type: NotificationType.MERIT_RECEIVED;
  readonly metadata: {
    readonly id: Merit["id"];
  };
};

type MeritUpdatedPayload = {
  readonly type: NotificationType.MERIT_UPDATED;
  readonly metadata: {
    readonly id: Merit["id"];
  };
};

type Payload = MeritReceivedPayload | MeritUpdatedPayload;

type PushNotificationPayloadState = {
  readonly clearPayload: () => void;
  readonly payload: Payload | undefined;
  readonly setPayloadFromNotificationResponse: (response: NotificationResponse) => void;
};

export const usePushNotificationPayloadStore = create<PushNotificationPayloadState>()(set => ({
  clearPayload: () => {
    set({ payload: undefined });
  },
  payload: undefined,
  setPayloadFromNotificationResponse: (response: NotificationResponse) => {
    const data = response.notification.request.content.data;
    // eslint-disable-next-line functional/no-let, @typescript-eslint/init-declarations
    switch (data.type) {
      case NotificationType.MERIT_RECEIVED:
        if (typeof data.metadata.id === "string") {
          set({
            payload: {
              metadata: {
                id: data.metadata.id,
              },
              type: data.type,
            },
          });
        }
        break;
      case NotificationType.MERIT_UPDATED:
        if (typeof data.metadata.id === "string") {
          set({
            payload: {
              metadata: {
                id: data.metadata.id,
              },
              type: data.type,
            },
          });
        }
        break;
      default:
        Log.error("push notification payload is not a recognized type", {
          notificationType: data.type,
        });
    }
  },
}));
